// extracted by mini-css-extract-plugin
export default {"divContainer":"FooterPanel_divContainer__lwMg1","footerPanel":"FooterPanel_footerPanel__HlCyK"};